// extracted by mini-css-extract-plugin
export default {"select":"SearchSelectMaterial_select__9CvAq"};